export const getProjectType = () => window.location.pathname.split('/')[1];
